import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=7383186f&scoped=true"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383186f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7383186f')) {
      api.createRecord('7383186f', component.options)
    } else {
      api.reload('7383186f', component.options)
    }
    module.hot.accept("./Collapse.vue?vue&type=template&id=7383186f&scoped=true", function () {
      api.rerender('7383186f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Collapse/Collapse.vue"
export default component.exports